import axios from "@/plugins/axios";
import $utils from "@/utils";
import utils from "@/stores/utils";
import { resolvePermissionCheck } from "@/utils/groupPermissions";
import allocations from "./submodules/allocations";
import orderitems from "./submodules/orderitems";
import shipmentitems from "./submodules/shipmentitems";
import receiptitems from "./submodules/receiptitems";
import providers from "./submodules/providers";
import catalogentries from "./submodules/catalogentries";

const { getStorageKey, loadFiltersFromStorage, saveFiltersToStorage } = utils;

/** In-flight stock line fetches by product id (dedupe concurrent mount/refetch bursts). */
const stockproductsInflightByProductId = new Map();

const state = {
    product: null,
    product_loading: false,
    product_loading_errors: null,
    product_deleting: false,

    product_saving: false,
    product_saving_errors: {},

    producttype: null,
    producttype_loading: false,
    producttype_loading_errors: null,

    evolution: null,
    evolutionPeriod: null,
    evolutionLoading: false,
    evolutionLoadingErrors: {},

    stock_weekly_stats: null,
    stock_weekly_stats_loading: false,

    movements: [],
    movements_filters: { 
        offset: 0,
        limit: 20,
        ordering: '-movement_date'
    },
    movements_count: 0,
    movements_loading: false,
    movements_loaded: false,
    movements_loading_errors: null,

    productpictures: [],
    productpictures_count: 0,
    productpictures_loading: false,
    productpictures_loading_errors: null,

    productpicture_saving: false,
    productpicture_saving_errors: null,

    productlinks: [],
    productlinks_count: 0,
    productlinks_filters: { limit: 20 },
    productlinks_loading: false,
    productlinks_loaded: false,
    productlinks_loading_errors: null,
    productlinks_saving: false,
    productlinks_saving_errors: null,

    stockproducts: [],
    stockproducts_count: 0,
    stockproducts_stats: null,
    stockproducts_stats_loading: false,
    stockproducts_loading: false,
    stockproducts_fetching_errors: null,
    /** Serialized list API params for the last successful stockproducts fetch. */
    stockproducts_cached_request: null,
    /** Paginated / filtered rows for the product stock tab table only. */
    stockproducts_table: [],
    stockproducts_table_count: 0,
    stockproducts_table_loading: false,
    stockproducts_table_fetching_errors: null,
    stockproducts_table_cached_request: null,
    stockproducts_table_loaded: false,

    compute_price_loading: false,

    section: null,

    product_stats: {},
    product_stats_loaded: false,
    product_stats_loading: false,
    product_stats_loading_errors: null,
};

let getMovementsFilters = function (product, filters) {
    return { product: product.id };
};

const mutations = {
    updateProduct(state, product) {
        state.product_saving = false;
        state.product_saving_errors = {};
        if (
            state.producttype &&
            String(state.producttype.id) !== String(product?.producttype)
        ) {
            state.producttype = null;
        }

        if (product && state.product && product.id && state.product.id) {
            if (product.id !== state.product.id) {
                state.stockproducts = [];
                state.stockproducts_count = 0;
                state.stockproducts_cached_request = null;
                state.stockproducts_stats = null;
                state.stockproducts_stats_loading = false;
                state.stockproducts_fetching_errors = null;
                state.stockproducts_table = [];
                state.stockproducts_table_count = 0;
                state.stockproducts_table_loading = false;
                state.stockproducts_table_fetching_errors = null;
                state.stockproducts_table_cached_request = null;
                state.stockproducts_table_loaded = false;
            }
            state.product = product;
            return;
        }
        state.product = product;
        state.product_stats = {};
        state.product_stats_loaded = false;

        state.movements = [];
        state.movements_count = 0;
        state.movements_loaded = false;
        state.stock_weekly_stats = null;

        state.productpictures = [];
        state.productpictures_count = 0;

        state.stockproducts = [];
        state.stockproducts_count = 0;
        state.stockproducts_stats = null;
        state.stockproducts_stats_loading = false;
        state.stockproducts_loading = false;
        state.stockproducts_fetching_errors = null;
        state.stockproducts_cached_request = null;
        state.stockproducts_table = [];
        state.stockproducts_table_count = 0;
        state.stockproducts_table_loading = false;
        state.stockproducts_table_fetching_errors = null;
        state.stockproducts_table_cached_request = null;
        state.stockproducts_table_loaded = false;
        state.movements_filters = {
            ordering: "-movement_date",
            limit: 20,
            ...loadFiltersFromStorage(getStorageKey('product', 'movements')),
            offset: 0,
            product: product?.id,
        };
    },

    updateSection(state, section) {
        state.section = section;
    },

    updateProductLoading(state, loading) {
        state.product_loading = loading;
    },
    updateProductLoadingErrors(state, errors) {
        state.product_loading_errors = errors;
    },

    updateProductSavingErrors(state, errors) {
        state.product_saving = false;
        state.product_saving_errors = errors;
    },
    updateProductSaving(state, saving) {
        state.product_saving = saving;
    },
    updateProductType(state, producttype) {
        state.producttype = producttype;
    },
    updateProductTypeLoading(state, loading) {
        state.producttype_loading = loading;
    },
    updateProductTypeLoadingErrors(state, errors) {
        state.producttype_loading_errors = errors;
    },

    updateProductDeleting(state, deleting) {
        state.product_deleting = deleting;
    },

    updateMovements(state, data) {
        state.movements = data.results;
        state.movements_count = data.count;
        state.movements_loaded = true;
    },
    updateMovementsLoading(state, loading) {
        state.movements_loading = loading;
    },
    updateMovementsLoadingErrors(state, errors) {
        state.movements_loading_errors = errors;
    },
    updateMovementsFilters(state, filters) {
        console.warn('updateMovementsFilters', filters);
        state.movements_filters = filters;
        saveFiltersToStorage(getStorageKey('product', 'movements'), state.movements_filters, ['limit', 'ordering']);
    },

    updateEvolution(state, evolution) {
        state.evolution = {
            labels: evolution.labels.map((label) => new Date(label)),
            datasets: evolution.datasets,
        };
        state.evolutionLoading = false;
        state.evolutionLoadingErrors = {};
    },
    updateEvolutionPeriod(state, evolutionPeriod) {
        state.evolution = null;
        state.evolutionPeriod = evolutionPeriod;
    },
    updateEvolutionLoading(state, evolutionLoading) {
        state.evolutionLoading = evolutionLoading;
    },
    updateEvolutionLoadingErrors(state, evolutionLoadingErrors) {
        state.evolutionLoading = false;
        state.evolutionLoadingErrors = evolutionLoadingErrors;
    },

    updateStockWeeklyStats(state, stats) {
        state.stock_weekly_stats = stats;
    },
    updateStockWeeklyStatsLoading(state, loading) {
        state.stock_weekly_stats_loading = loading;
    },

    updateProductLinks(state, productlinks) {
        state.productlinks = productlinks;
        state.productlinks_saving_errors = null;
    },
    updateProductLinksFilters(state, filters) {
        state.productlinks_filters = filters;
        saveFiltersToStorage(getStorageKey('product', 'productlinks'), state.productlinks_filters, ['limit', 'ordering']);
    },
    updateProductLinksCount(state, count) {
        state.productlinks_count = count;
    },
    updateProductLinksLoading(state, loading) {
        state.productlinks_loading = loading;
    },
    updateProductLinksLoaded(state, loaded) {
        state.productlinks_loaded = loaded;
    },
    updateProductLinksLoadingErrors(state, errors) {
        state.productlinks_loading_errors = errors;
    },
    updateProductLinksSavingErrors(state, errors) {
        state.productlinks_saving = false;
        state.productlinks_saving_errors = errors;
    },
    updateProductLinksSaving(state, saving) {
        state.productlinks_saving = saving;
    },

    updateProductPictures(state, productpictures) {
        state.productpictures = productpictures;
    },
    updateProductPicturesCount(state, count) {
        state.productpictures_count = count;
    },
    updateProductPicturesLoading(state, loading) {
        state.productpictures_loading = loading;
    },
    updateProductPicturesLoadingErrors(state, errors) {
        state.productpictures_loading_errors = errors;
    },

    updateProductPictureSavingErrors(state, errors) {
        state.productpicture_saving_errors = errors;
    },
    updateProductPictureSaving(state, saving) {
        state.productpicture_saving = saving;
    },

    updateStockProducts(state, stockproducts) {
        state.stockproducts = stockproducts;
        state.stockproducts_fetching_errors = null;
    },
    updateStockProductsCount(state, count) {
        state.stockproducts_count = count ?? 0;
    },
    updateStockProductsTable(state, stockproducts) {
        state.stockproducts_table = stockproducts || [];
        state.stockproducts_table_fetching_errors = null;
    },
    updateStockProductsTableCount(state, count) {
        state.stockproducts_table_count = count ?? 0;
    },
    updateStockProductsTableLoading(state, loading) {
        state.stockproducts_table_loading = loading;
    },
    updateStockProductsTableFetchingErrors(state, errors) {
        state.stockproducts_table_fetching_errors = errors;
        if (errors) {
            state.stockproducts_table_cached_request = null;
        }
    },
    updateStockProductsTableCachedRequest(state, signature) {
        state.stockproducts_table_cached_request = signature ?? null;
    },
    updateStockProductsTableLoaded(state, loaded) {
        state.stockproducts_table_loaded = loaded;
    },
    patchStockProductLocation(state, { id, location }) {
        const patchRow = (row) =>
            row.id === id ? { ...row, location } : row;
        state.stockproducts = (state.stockproducts || []).map(patchRow);
        state.stockproducts_table = (state.stockproducts_table || []).map(
            patchRow,
        );
    },
    updateStockProductsStats(state, stats) {
        state.stockproducts_stats = stats || null;
    },
    updateStockProductsStatsLoading(state, loading) {
        state.stockproducts_stats_loading = loading;
    },
    updateStockProductsLoading(state, loading) {
        state.stockproducts_loading = loading;
    },
    updateStockProductsFetchingErrors(state, errors) {
        state.stockproducts_fetching_errors = errors;
        if (errors) {
            state.stockproducts_cached_request = null;
        }
    },

    updateStockProductsCachedRequest(state, signature) {
        state.stockproducts_cached_request = signature ?? null;
    },

    invalidateStockProductsCache(state) {
        state.stockproducts_cached_request = null;
        state.stockproducts_table_cached_request = null;
    },

    updateComputePriceLoading(state, loading) {
        state.compute_price_loading = loading;
    },

    updateProductStats(state, stats) {
        state.product_stats = stats;
    },
    updateProductStatsLoaded(state, loaded) {
        state.product_stats_loaded = loaded;
    },
    updateProductStatsLoading(state, loading) {
        state.product_stats_loading = loading;
    },
    updateProductStatsLoadingErrors(state, errors) {
        state.product_stats_loading_errors = errors;
    },
};

const actions = {
    async fetchProductStats({ commit, dispatch, state }, params) {
        await commit("updateProductStatsLoading", true);
        try {
            const response = await axios.get(`/api/products/${state.product.id}/stats/`);
            await commit("updateProductStats", response.data);
            await commit("updateProductStatsLoaded", true);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            await commit("updateProductLoadingErrors", error.details);
            throw error;
        } finally {
            await commit("updateProductStatsLoading", false);
        }
    },

    async fetchStockWeeklyStats({ commit, state }) {
        if (!state.product?.id) {
            return;
        }
        commit("updateStockWeeklyStatsLoading", true);
        try {
            const params = { ...state.movements_filters };
            delete params.offset;
            delete params.limit;
            delete params.ordering;
            params.movement_date_max = new Date().toISOString().slice(0, 10);
            const response = await axios.get("/api/movements/inventory/weekly-stats/", {
                params,
            });
            commit("updateStockWeeklyStats", response.data);
            return response.data;
        } catch (xhr_error) {
            commit("updateStockWeeklyStats", []);
            utils.handleError(xhr_error);
        } finally {
            commit("updateStockWeeklyStatsLoading", false);
        }
    },

    async assignSalesCatalogs({ state }, { catalogIds, productId, catalogConfigs }) {
        const targetProductId = productId || state.product?.id;
        if (!targetProductId) {
            throw new Error("No product loaded");
        }
        try {
            const payload = { catalogs: catalogIds };
            if (catalogConfigs && Object.keys(catalogConfigs).length > 0) {
                payload.catalog_configs = catalogConfigs;
            }
            const response = await axios.post(
                `/api/products/${targetProductId}/catalogs/`,
                payload
            );
            return response.data;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async fetchProduct({ commit, dispatch, state }, params) {
        commit("updateProductLoading", true);
        let url = null;
        if (params && params.product_id) {
            url = `/api/products/${params.product_id}/`;
        } else if (state.product) {
            url = `/api/products/${state.product.id}/`;
        } else {
            throw "no product to fetch";
        }
        try {
            const response = await axios.get(url);
            commit("updateProduct", response.data);
            await dispatch("fetchProductType");
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateProductLoading", false);
        }
    },


    async patchProduct({ commit }, params) {
        commit("updateProductSaving", true);
        try {
            const url = `/api/products/${params.instance.id}/`;
            const response = await axios.patch(url, params.instance);
            commit("updateProduct", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductSavingErrors", error.details);
            throw error;
        } finally {
            commit("updateProductSaving", false);
        }
    },

    async deleteProduct({ commit, dispatch, state }, params) {
        commit("updateProductDeleting", true);

        const url = `/api/products/${params.instance.id}/archive/`;
        try {
            const response = await axios.post(url);
            dispatch("session/fetchStats", null, { root: true });
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateProductDeleting", false);
        }
    },

    async unarchiveProduct({ commit, dispatch, state }, params) {
        try {
            await axios.post(`/api/products/${state.product.id}/unarchive/`);
        } finally {
            dispatch("fetchProduct");
        }
    },

    async fetchMovements({ commit, dispatch, state }, params) {
        if (!state.product) {
            return;
        }
        commit("updateMovementsLoading", true);
        commit("updateMovementsLoadingErrors", null);

        try {
            const response = await axios.get("/api/movements/", {
                params: state.movements_filters,
            });
            commit("updateMovements", response.data);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateMovementsLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateMovementsLoading", false);
        }
    },

    async fetchProductPictures({ commit, dispatch, state }, params) {
        commit("updateProductPicturesLoading", true);
        commit("updateProductPicturesLoadingErrors", null);

        try {
            const response = await axios.get("/api/productpictures/", {
                params: { limit: 100, product: state.product.id },
            });
            commit("updateProductPictures", response.data.results);
            commit("updateProductPicturesCount", response.data.count);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductPicturesLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateProductPicturesLoading", false);
        }
    },

    async deleteProductLink({ commit, dispatch, state }, productlink) {
        try {
            const response = await axios.delete(
                `/api/productlinks/${productlink.id}/`
            );
            dispatch('fetchProductLinks');
            dispatch('fetchProduct');
        } catch (error) {
            throw utils.handleError(error);
        }
    },

    async changeCatalogEntryPrice({ commit, dispatch, state }, params) {
        try {
            const unit_amount = $utils.normalizeAmountForApi(params.unit_amount);
            const response = await axios.patch(`/api/providercatalogentries/${params.catalogentry_id}/`, {
                unit_amount,
            });
            dispatch("fetchProductLinks");
            dispatch("fetchProduct");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async fetchProductLinks({ commit, dispatch, state, rootGetters }, params) {
        if (
            !resolvePermissionCheck(
                rootGetters["session/current_user_permissions"],
                "core.view_productlink",
            ) &&
            !resolvePermissionCheck(
                rootGetters["session/current_user_permissions"],
                "core.view_provider",
            )
        ) {
            commit("updateProductLinks", []);
            commit("updateProductLinksCount", 0);
            commit("updateProductLinksLoaded", true);
            commit("updateProductLinksLoading", false);
            return;
        }

        commit("updateProductLinksLoading", true);
        commit("updateProductLinksLoadingErrors", null);

        const filters = {
            ...state.productlinks_filters,
            ...loadFiltersFromStorage(getStorageKey('product', 'productlinks'), { limit: 20, ordering: "id" }),
        };

        commit('updateProductLinksFilters', filters);

        try {
            const response = await axios.get(`/api/productlinks/`, {
                params: {
                    ...filters,
                    child: state.product.id,
                },
            });
            commit("updateProductLinks", response.data.results);
            commit("updateProductLinksCount", response.data.count);
            commit('updateProductLinksLoaded', true);
            commit("updateProductLinksLoading", false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductLinksLoadingErrors", error.details);
            commit('updateProductLinksLoaded', true);
            commit("updateProductLinksLoading", false);
            throw error;
        }
    },

    async fetchProductType({ commit, state }, params) {
        const producttypeId =
            params?.producttype_id || state.product?.producttype;
        if (!producttypeId) {
            commit("updateProductType", null);
            commit("updateProductTypeLoading", false);
            commit("updateProductTypeLoadingErrors", null);
            return null;
        }
        if (String(state.producttype?.id) === String(producttypeId)) {
            return state.producttype;
        }
        commit("updateProductTypeLoading", true);
        commit("updateProductTypeLoadingErrors", null);
        try {
            const response = await axios.get(`/api/producttypes/${producttypeId}/`);
            commit("updateProductType", response.data);
            return response.data;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductType", null);
            commit("updateProductTypeLoadingErrors", error.details);
            throw error;
        } finally {
            commit("updateProductTypeLoading", false);
        }
    },

    async saveProductPicture({ commit, dispatch, state }, params) {
        if (!params || !params.instance) {
            return;
        }

        let headers = {};
        let data = params.instance;
        let url = "/api/productpictures/";
        let method = axios.post;

        if (params.instance.id) {
            url = `/api/productpictures/${params.instance.id}/`;
            method = params.patch ? axios.patch : axios.put;
        } else {
            headers = { "Content-Type": "multipart/form-data" };
            data = new FormData();
            for (let key in params.instance) {
                if (params.instance[key]) {
                    data.append(key, params.instance[key]);
                }
            }
        }

        commit("updateProductPictureSavingErrors", null);
        commit("updateProductPictureSaving", true);

        try {
            const response = await method(url, data, { headers });
            commit("updateProductPictureSaving", false);
            return { productpicture: response.data };
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductPictureSavingErrors", error.details);
            commit("updateProductPictureSaving", false);
            throw error;
        }
    },

    async deleteProductPicture({ commit, dispatch, state }, params) {
        const url = `/api/productpictures/${params.instance.id}/`;

        try {
            const response = await axios.delete(url);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async fetchStockProducts({ dispatch }, opts = {}) {
        await dispatch("fetchChildStockProducts", opts);
        if (opts?.force) {
            await dispatch("refreshStockTabTableIfLoaded");
        }
    },

    async refreshStockTabTableIfLoaded({ state, dispatch }) {
        if (!state.product?.id || !state.stockproducts_table_loaded) {
            return;
        }
        const filters = utils.filtersFromStockTableCache(
            state.stockproducts_table_cached_request,
        );
        await dispatch("fetchChildStockProducts", {
            force: true,
            target: "table",
            filters,
        });
        return dispatch("fetchChildStockProductsStats", { filters });
    },

    async fetchChildStockProducts(
        { commit, state },
        { force = false, filters = null, target = "summary" } = {},
    ) {
        if (!state.product?.id) {
            if (target === "table") {
                commit("updateStockProductsTable", []);
                commit("updateStockProductsTableCount", 0);
                commit("updateStockProductsTableCachedRequest", null);
                commit("updateStockProductsTableLoading", false);
                commit("updateStockProductsTableLoaded", false);
            } else {
                commit("updateStockProducts", []);
                commit("updateStockProductsCount", 0);
                commit("updateStockProductsCachedRequest", null);
                commit("updateStockProductsLoading", false);
            }
            stockproductsInflightByProductId.clear();
            return;
        }
        const productId = state.product.id;
        const listFilters = filters || {};
        const apiParams = {
            limit: listFilters.limit ?? 2000,
            offset: listFilters.offset ?? 0,
        };
        if (target === "table") {
            apiParams.product_with_providers = productId;
        } else {
            apiParams.product = productId;
        }
        const search = (listFilters.search || "").trim();
        if (search) {
            apiParams.search = search;
        }
        if (listFilters.stock != null && listFilters.stock !== "") {
            apiParams.stock = listFilters.stock;
        }
        if (listFilters.stock_owner) {
            apiParams.stock_owner = listFilters.stock_owner;
        }
        const cacheSignature = JSON.stringify(apiParams);
        const key = `${target}:${cacheSignature}`;
        const isTable = target === "table";
        const cachedRequest = isTable
            ? state.stockproducts_table_cached_request
            : state.stockproducts_cached_request;
        const fetchingErrors = isTable
            ? state.stockproducts_table_fetching_errors
            : state.stockproducts_fetching_errors;

        if (
            !force &&
            cachedRequest === cacheSignature &&
            !fetchingErrors
        ) {
            return isTable ? state.stockproducts_table : state.stockproducts;
        }

        if (force) {
            stockproductsInflightByProductId.delete(key);
        }
        const existing = stockproductsInflightByProductId.get(key);
        if (!force && existing) {
            return existing;
        }

        const promise = (async () => {
            if (isTable) {
                commit("updateStockProductsTableLoading", true);
                commit("updateStockProductsTableFetchingErrors", null);
            } else {
                commit("updateStockProductsLoading", true);
                commit("updateStockProductsFetchingErrors", null);
            }
            try {
                const response = await axios.get("/api/stockproducts/", {
                    params: apiParams,
                });
                const results = response.data.results || [];
                const count = response.data.count ?? 0;
                if (isTable) {
                    commit("updateStockProductsTable", results);
                    commit("updateStockProductsTableCount", count);
                    commit(
                        "updateStockProductsTableCachedRequest",
                        cacheSignature,
                    );
                    commit("updateStockProductsTableLoaded", true);
                } else {
                    commit("updateStockProducts", results);
                    commit("updateStockProductsCount", count);
                    commit("updateStockProductsCachedRequest", cacheSignature);
                }
                return results;
            } catch (xhr_error) {
                const error = utils.handleError(xhr_error);
                if (isTable) {
                    commit(
                        "updateStockProductsTableFetchingErrors",
                        error.details,
                    );
                    commit("updateStockProductsTable", []);
                    commit("updateStockProductsTableCount", 0);
                    commit("updateStockProductsTableCachedRequest", null);
                    commit("updateStockProductsTableLoaded", true);
                } else {
                    commit("updateStockProductsFetchingErrors", error.details);
                    commit("updateStockProducts", []);
                    commit("updateStockProductsCount", 0);
                    commit("updateStockProductsCachedRequest", null);
                }
                throw error;
            } finally {
                if (isTable) {
                    commit("updateStockProductsTableLoading", false);
                } else {
                    commit("updateStockProductsLoading", false);
                }
            }
        })()
            .finally(() => {
                if (stockproductsInflightByProductId.get(key) === promise) {
                    stockproductsInflightByProductId.delete(key);
                }
            });

        stockproductsInflightByProductId.set(key, promise);
        return promise;
    },

    async fetchChildStockProductsStats({ commit, state }, { filters = null } = {}) {
        if (!state.product?.id) {
            commit("updateStockProductsStats", null);
            return;
        }
        const listFilters = filters || {};
        const apiParams = {
            product_with_providers: state.product.id,
        };
        const search = (listFilters.search || "").trim();
        if (search) {
            apiParams.search = search;
        }
        if (listFilters.stock != null && listFilters.stock !== "") {
            apiParams.stock = listFilters.stock;
        }
        if (listFilters.stock_owner) {
            apiParams.stock_owner = listFilters.stock_owner;
        }
        commit("updateStockProductsStatsLoading", true);
        try {
            const response = await axios.get("/api/stockproducts/stats/", {
                params: apiParams,
            });
            commit("updateStockProductsStats", response.data);
            return response.data;
        } catch (xhr_error) {
            commit("updateStockProductsStats", null);
            utils.handleError(xhr_error);
        } finally {
            commit("updateStockProductsStatsLoading", false);
        }
    },

    async activateAllocation({ commit, dispatch, state }, params) {
        try {
            const response = await axios.patch(`/api/products/${state.product.id}/`, {
                requires_allocation: true,
            });
            await dispatch("fetchProduct");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            throw error;
        }
    },

    async saveProductLinks({ commit, dispatch, state }, params) {
        commit("updateProductLinksSaving", true);
        commit("updateProductLinksSavingErrors", null);

        try {
            const response = await axios.patch(`/api/products/${state.product.id}/`, {
                providers: state.productlinks,
            });
            commit("updateProductLinksSaving", false);
            dispatch("fetchProduct");
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit("updateProductLinksSavingErrors", error.details);
            commit("updateProductLinksSaving", false);
            throw error;
        }
    },

    async activateStockTracking({ commit, dispatch, state }, params) {
        try {
            const response = await axios.patch(`/api/products/${state.product.id}/`, {
                stock_tracking: true,
            });
            commit("updateProduct", response.data);
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        }
    },

    async computeBetterPurchasePrice({ commit, dispatch, state }, params) {
        commit("updateComputePriceLoading", true);
        try {
            const response = await axios.post(`/api/products/${state.product.id}/compute-better-purchase-price/`);
            // Reload the product to get updated purchase price
            dispatch("fetchProduct");
            return response;
        } catch (xhr_error) {
            throw utils.handleError(xhr_error);
        } finally {
            commit("updateComputePriceLoading", false);
        }
    },

    update({ commit, dispatch, state }, params) {
        dispatch("fetchProduct");
        dispatch("fetchProductStats");
    },

    async init({ commit, dispatch, state, rootGetters }, params) {
        await commit("updateProductStats", {});
        await commit('updateProductLinksLoaded', false);
        await commit("updateSection", params.section || null);
        await dispatch("allocations/init", {
            filters: { product: params.product.id },
        });
        await dispatch("customerorderitems/init", {
            filters: {
                product: params.product.id,
                order_suborder: false,
                order_seller_entity: rootGetters["session/current_entity_id"],
            },
            type: "customerorder",
        });
        await dispatch("providerorderitems/init", {
            filters: { product: params.product.id, suborder: false },
            type: "providerorder",
        });
        await dispatch("shipmentitems/init", {
            filters: { product: params.product.id },
        });
        await dispatch("receiptitems/init", {
            filters: { product: params.product.id },
        });
        await dispatch("providers/init", {
            filters: { connected: false, limit: 1000, ordering: "name" },
        });
        await dispatch("catalogentries/init", {
            filters: { product: params.product.id },
        });
        await commit("updateProduct", params.product);
        await dispatch("fetchProductType");
        await dispatch("fetchProductStats");
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        allocations: allocations({
            storageKey: getStorageKey('product', 'allocations'),
            fieldsToSave: ['limit', 'ordering']
        }),
        customerorderitems: orderitems({
            storageKey: getStorageKey('product', 'customerorderitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        providerorderitems: orderitems({
            storageKey: getStorageKey('product', 'providerorderitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        shipmentitems: shipmentitems({
            storageKey: getStorageKey('product', 'shipmentitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        receiptitems: receiptitems({
            storageKey: getStorageKey('product', 'receiptitems'),
            fieldsToSave: ['limit', 'ordering']
        }),
        providers: providers({
            storageKey: getStorageKey('product', 'providers'),
            fieldsToSave: ['limit', 'ordering']
        }),
        catalogentries: catalogentries({
            storageKey: getStorageKey('product', 'catalogentries'),
            fieldsToSave: ['limit', 'ordering']
        }),
    },
};
